import { render, staticRenderFns } from "./GroupedEndpoints.vue?vue&type=template&id=2d0f9668&"
import script from "./GroupedEndpoints.vue?vue&type=script&lang=js&"
export * from "./GroupedEndpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports